import React, { useEffect, useState } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { CoreUtils, Select } from '@nhl/nhl-breakaway-ui';

import { statsConfigSelectors } from '~/redux/ducks/config';
import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';
import { PLAYOFFS_ID } from '~/utility/constants';

import Label from '../../label';
import { SelectContainer } from '../styles';

const ReportSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const location = useLocation();

    const setReportName = (e, { value }) => {
        dispatch(reportActionCreators.setReportName(value));
        dispatch(reportActionCreators.runReport());
    };

    const statsConfig = useSelector((state) => state.config);
    const gameTypeId = useSelector((state) => state.playersAndTeams.report.current.gameTypeId);
    const selectedReport = useSelector((state) => state.playersAndTeams.report.current.reportName);
    const timeFrame = useSelector((state) => state.playersAndTeams.report.current.timeFrame);

    const [reportData, setReportData] = useState(
        statsConfigSelectors.getReportDataForTimeFrame(statsConfig, timeFrame),
    );

    useEffect(() => {
        setReportData(statsConfigSelectors.getReportDataForTimeFrame(statsConfig, timeFrame));
    }, [location.pathname]);

    const tentativeOptions = Object.keys(reportData)
        .filter((reportName) => reportData[reportName])
        .map((report) => ({
            value: report,
            label: CoreUtils.safeFormatMessage(intl, commonMessages.reportName?.[report], report),
            key: report,
        }))
        .sort((a, b) => {
            if (a.value === 'summary') {
                return -1;
            }
            if (b.value === 'summary') {
                return 1;
            }
            return a.label.localeCompare(b.label);
        });
    const options =
        gameTypeId === PLAYOFFS_ID ? tentativeOptions.filter((obj) => obj.value !== 'shootout') : tentativeOptions;
    const value = options.find((obj) => obj.value === selectedReport);
    return (
        <SelectContainer>
            <Label htmlFor="report">
                <FormattedMessage {...commonMessages.labels.report} />
            </Label>
            <Select
                onOptionChange={setReportName}
                options={options}
                name="report"
                selectedOption={value}
                isSearchEnabled
                optionsBoxAriaLabel={intl.formatMessage(commonMessages.labels.report)}
                dropdownButtonAriaLabel=""
            />
        </SelectContainer>
    );
};

export default React.memo(ReportSelect);
